import React, { useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/ko'

// components
import DefaultImg from '../../assets/image/logo/ic-default.svg'
import { BoxShadow } from '../atom'

// styles
import colors from '../../styles/colors'

const ShopInfo = ({ data, logo }) => {
  const checkOpen = (data) => {
    if (!data) return false

    const {
      closedDay, // 휴무일
      happyorderYn, // 해피오더
      shopHoursStart, // 운영시간 시작
      shopHoursEnd, // 운영시간 마감
    } = data

    const currentDay = moment().format('YYYYMMDD') // 오늘
    const currentTime = moment().format('HHmm') // 현재 시간

    // 영업시간 시작
    const shopHoursStartTime = moment({
      hour:
        shopHoursStart.length === 4
          ? shopHoursStart.slice(0, 2)
          : shopHoursStart.slice(0, 1),
      minute:
        shopHoursStart.length === 4
          ? shopHoursStart.slice(2, 4)
          : shopHoursStart.slice(1, 4),
    }).format('HHmm') // 영업 시작 시간

    // 영업시간 마감
    const shopHoursEndTime = moment({
      hour:
        shopHoursEnd.length === 4
          ? shopHoursEnd.slice(0, 2)
          : shopHoursEnd.slice(0, 1),
      minute:
        shopHoursEnd.length === 4
          ? shopHoursEnd.slice(2, 4)
          : shopHoursEnd.slice(1, 4),
    }).format('HHmm') // 영업 시작 시간

    if (closedDay?.includes(currentDay)) {
      return false
    }
    // 휴무일 아니고
    else {
      // 해피오더 켜짐 or 영업시간 내
      if (
        happyorderYn === 'Y' ||
        (shopHoursStartTime <= currentTime && shopHoursEndTime >= currentTime)
      ) {
        return true
      } else {
        return false
      }
    }
  }

  return (
    <Wrapper>
      <BoxShadow>
        <ShopWrapper>
          <TitleShop>매장정보</TitleShop>

          <LogoAreaShop>
            <img src={logo ?? DefaultImg} />
            <div>
              <span>{data?.storeName ?? '매장이름'}</span>
              <span>{data?.brandName ?? '브랜드이름'}</span>
            </div>
          </LogoAreaShop>

          <InfoWrapper>
            <BoxInfo isTop={true}>
              <div>주소</div>
              <div>
                <span>
                  {(data?.address || '') + ' ' + (data?.addressDetail || '') ||
                    '-'}
                </span>
                {data?.address && (
                  <span>
                    * 위 정보의 변경이 필요한 경우 고객센터로 문의해주세요
                  </span>
                )}
              </div>
            </BoxInfo>
            <BoxInfo>
              <div>매장코드</div>
              <div>{data?.storeCode ?? '-'}</div>
            </BoxInfo>
            <BoxInfo>
              <div>매장운영시간</div>
              <div>
                {data?.shopHoursStart && data?.shopHoursEnd
                  ? `${data.shopHoursStart.slice(
                      0,
                      2,
                    )}:${data.shopHoursStart.slice(
                      2,
                    )} ~ ${data.shopHoursEnd.slice(
                      0,
                      2,
                    )}:${data.shopHoursEnd.slice(2)}`
                  : '-'}
                {/* {data?.shopHoursStart
                  ? `${moment(
                      data?.shopHoursStart.length === 4
                        ? data?.shopHoursStart
                        : `0${data?.shopHoursStart}`,
                      'HHmm',
                    ).format('HH:mm')} ~ ${moment(
                      data?.shopHoursEnd.length === 4
                        ? data?.shopHoursEnd
                        : `0${data?.shopHoursEnd}`,
                      'HHmm',
                    ).format('HH:mm')}`
                  : '-'} */}
              </div>
            </BoxInfo>
            <BoxInfo>
              <div>배달가능시간</div>
              <div>
                {data?.orderHoursStart && data?.orderHoursEnd
                  ? `${data.orderHoursStart.slice(
                      0,
                      2,
                    )}:${data.orderHoursStart.slice(
                      2,
                    )} ~ ${data.orderHoursEnd.slice(
                      0,
                      2,
                    )}:${data.orderHoursEnd.slice(2)}`
                  : '-'}
                {/* {data?.shopHoursStart
                  ? `${moment(
                      data?.orderHoursStart.length === 4
                        ? data?.orderHoursStart
                        : `0${data?.orderHoursStart}`,
                      'HHmm',
                    ).format('HH:mm')} ~ ${moment(
                      data?.orderHoursEnd.length === 4
                        ? data?.orderHoursEnd
                        : `0${data?.orderHoursEnd}`,
                      'HHmm',
                    ).format('HH:mm')}`
                  : '-'} */}
              </div>
            </BoxInfo>
            <BoxInfo>
              <div>전화번호</div>
              <div>{data?.tel ?? '-'}</div>
            </BoxInfo>
            <BoxInfo>
              <div>점주 연락처</div>
              <div>
                {data?.mobile?.replace(
                  /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
                  '$1-$2-$3',
                ) ?? '-'}
              </div>
            </BoxInfo>
            <BoxInfo>
              <div>매장상태</div>
              <div>{checkOpen(data) ? '영업중' : '영업준비중'}</div>
              {/* <div>{data?.happyorderYn === 'Y' ? '영업중' : '영업준비중'}</div> */}
            </BoxInfo>
          </InfoWrapper>
        </ShopWrapper>

        {/* <ShopInfoWrap>
          <h2 className="shopTit">매장정보</h2>
          <StoreBox>
            <StoreImgBox>
              {logo ? (
                <img src={logo} alt="" />
              ) : (
                <img src={DefaultImg} alt="" />
              )}
            </StoreImgBox>

            <div>
              <h4 className="storeTxt">
                {data?.storeName ? data?.storeName : '매장이름'}
              </h4>
              <h4 className="storeTxtBold">
                {data?.brandName ? data?.brandName : '브랜드이름'}
              </h4>
            </div>
          </StoreBox>
          <StoreInfoBox>
            <StoreInfoBtw>
              <dt className="storeDt">주소</dt>
              <dd className="storeTxt">
                {data?.address ? (
                  <>
                    <p className="storeAddress">{data?.address}</p>
                    <p className="storeRefer">
                      * 위 정보의 변경이 필요한 경우 고객센터로 문의해주세요
                    </p>
                  </>
                ) : (
                  '-'
                )}
              </dd>
            </StoreInfoBtw>
            <StoreInfoBtw>
              <dt className="storeDt">매장코드</dt>
              <dd className="storeTxt">
                {data?.storeCode ? data?.storeCode : '-'}
              </dd>
            </StoreInfoBtw>
            <StoreInfoBtw>
              <dt className="storeDt">매장운영시간</dt>
              <dd className="storeTxt">
                {data?.shopHoursStart
                  ? `${moment(
                      data?.shopHoursStart.length === 4
                        ? data?.shopHoursStart
                        : `0${data?.shopHoursStart}`,
                      'HHmm',
                    ).format('HH:mm')} ~ ${moment(
                      data?.shopHoursEnd.length === 4
                        ? data?.shopHoursEnd
                        : `0${data?.shopHoursEnd}`,
                      'HHmm',
                    ).format('HH:mm')}`
                  : '-'}
              </dd>
            </StoreInfoBtw>
            <StoreInfoBtw>
              <dt className="storeDt">배달가능시간</dt>
              <dd className="storeTxt">
                {data?.shopHoursStart
                  ? `${moment(
                      data?.orderHoursStart.length === 4
                        ? data?.orderHoursStart
                        : `0${data?.orderHoursStart}`,
                      'HHmm',
                    ).format('HH:mm')} ~ ${moment(
                      data?.orderHoursEnd.length === 4
                        ? data?.orderHoursEnd
                        : `0${data?.orderHoursEnd}`,
                      'HHmm',
                    ).format('HH:mm')}`
                  : '-'}
              </dd>
            </StoreInfoBtw>
            <StoreInfoBtw>
              <dt className="storeDt">전화번호</dt>
              <dd className="storeTxt">{data?.tel ? data?.tel : '-'}</dd>
            </StoreInfoBtw>
            <StoreInfoBtw>
              <dt className="storeDt">점주연락처</dt>
              <dd className="storeTxt">{data?.mobile ? data?.mobile : '-'}</dd>
            </StoreInfoBtw>
            <StoreInfoBtw>
              <dt className="storeDt">매장상태</dt>
              <dd className="storeTxt">
                {data?.happyorderYn === 'Y' ? '영업중' : '영업준비중'}
              </dd>
            </StoreInfoBtw>
          </StoreInfoBox>
        </ShopInfoWrap> */}
      </BoxShadow>
    </Wrapper>
  )
}

export default ShopInfo

const Wrapper = styled.div`
  max-width: 768px;
  width: 100%;
`

const ShopWrapper = styled.div`
  padding: 13px 7px;
  display: flex;
  flex-direction: column;

  @media ${(props) => props.theme.mobile} {
    padding: 0px;
  }
`

const TitleShop = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${colors.BK};

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`

const LogoAreaShop = styled.div`
  display: flex;
  margin-top: 21px;
  margin-bottom: 18px;
  align-items: center;

  img {
    width: 80px;
    height: 80px;
  }

  div {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    margin-left: 20px;
    color: ${colors.BK};
    word-break: break-all;
    white-space: pre-wrap;

    @media ${(props) => props.theme.mobile} {
      margin-left: 11px;
      font-size: 14px;
    }

    span:nth-child(1) {
      font-weight: bold;
    }
    span:nth-child(2) {
      margin-top: 4px;
      font-weight: normal;
    }
  }

  @media ${(props) => props.theme.mobile} {
    margin-top: 20px;
  }
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 100px;
  margin-bottom: 26px;

  @media ${(props) => props.theme.mobile} {
    margin-left: 0;
    margin-bottom: 20px;
  }
`

const BoxInfo = styled.div`
  display: flex;
  margin-top: ${(props) => !props.isTop && '23px'};
  word-break: break-all;
  white-space: pre-wrap;

  div:nth-child(1) {
    font-size: 16px;
    color: ${colors.D3};
    width: 118px;

    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }
  }

  div:nth-child(2) {
    flex: 1;
    font-size: 16px;
    color: ${colors.BK};
    display: flex;
    flex-direction: column;
    margin-left: 2px;

    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }

    span:nth-child(1) {
      font-size: 16px;
      color: ${colors.BK};

      @media ${(props) => props.theme.mobile} {
        font-size: 14px;
      }
    }

    span:nth-child(2) {
      font-size: 14px;
      color: ${colors.D3};
      margin-top: 8px;
      line-height: normal;

      @media ${(props) => props.theme.mobile} {
        font-size: 13px;
        line-height: 1.54;
      }
    }
  }
`

const ShopInfoWrap = styled.section`
  padding: 35px 29px;
  display: flex;
  flex-direction: column;
  .shopTit {
    font-size: 16px;
    font-weight: bold;
    color: ${colors.BK};
    margin-bottom: 21px;
  }
  .storeTxt {
    font-size: 16px;
    color: ${colors.BK};
    max-width: 80%;
  }

  .storeTxtBold {
    font-size: 16px;
    color: ${colors.BK};
    font-weight: bold;
    margin: 5px 0 16px;
  }

  @media ${(props) => props.theme.mobile} {
    padding: 0;
  }
`
const StoreBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  gap: 20px;
`
const StoreImgBox = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  img {
    width: 80px;
    height: 80px;
    object-fit: cover;
  }
`
const StoreInfoBox = styled.dl`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 18px;
  margin-left: 100px;
  @media ${(props) => props.theme.mobile} {
    margin: 20px 0px 0px;
  }
`
const StoreInfoBtw = styled.div`
  display: flx;
  flex-direction: row;
  justify-content: space-around;
  gap: 20px;

  .storeDt {
    min-width: 88px;
    text-align: left;
    font-size: 16px;
    color: ${colors.D3};
    line-height: 1.5;
  }

  .storeRefer {
    margin: 7px 0px;
    font-size: 14px;
    color: ${colors.D3};
    line-height: 1.5;

    @media ${(props) => props.theme.mobile} {
      width: 70%;
    }
  }

  .storeAddress {
    line-height: 1.5;

    @media ${(props) => props.theme.mobile} {
      width: 70%;
    }
  }
`
